import {orderBy, find, merge, debounce} from 'lodash';
import defaultOptions from "./config/ConfiguratorOptions";
import ChartInteractions from "./lib/chart";
import Sort from "./lib/Sort";
import {isEmpty} from 'lodash'
import ListingData from "./lib/ListingData";
import CalculatorLabels from "./lib/CalculatorLabels";


const Listing = {
  get store() {
    return this.$store.configurator
  },

  set store(data) {
    this.store.listingData = data
  },

  labels: CalculatorLabels(),
  calculationStyle: 'metric',

  toggleItems($event) {
    !$event.target.checked ? this.uncheckAllItems() : this.checkAllItems()
    ChartInteractions.updateChartData()
  },

  toggleItem($event, nid) {
    !$event.target.checked ? this.unCheckItem(nid) : this.checkItem(nid)
    ChartInteractions.updateChartData()
  },

  checkItem(nid) {
    this.store.listingDataChecked.push(nid)
  },

  unCheckItem(nid) {
    this.store.listingDataChecked = this.store.listingDataChecked.filter(item => item !== nid)

    this.rowIsActive(nid) && (this.store.listActiveItem = null)
    !this.isMinOneItemSelected() && this.uncheckBulkSelect()
  },

  checkAllItems() {
    this.checkAllStoredItems()
    this.setCheckboxes(true)
  },

  checkAllStoredItems() {
    this.store.listingDataChecked = this.store.listingData.map((item) => {
      return item.nid
    })
  },

  isMinOneItemSelected() {
    return !isEmpty(this.store.listingDataChecked)
  },

  uncheckAllItems() {
    this.store.listingDataChecked = []
    this.setCheckboxes(false)
    this.store.listActiveItem = null
  },

  isChecked(nid) {
    return this.store.listingDataChecked.some((item) => item === nid)
  },

  toggleSortBy(name) {
    Sort.toggle(name)
    this.reOrderListingData(name, !isEmpty(this.store.listingDataChecked))
  },

  setCheckboxes(value) {
    [...this.allCheckboxes].map((box) => {
      box.checked = value
    })
  },

  reOrderListingData(name, recreateCheckboxes = false) {

    this.store.listingData = JSON.parse(JSON.stringify(
      orderBy(this.store.listingData, [name], [this.getSortDirection(name)])
    ))

    recreateCheckboxes && this.recreateCheckboxes()
  },

  getSortDirection(name) {
    return Sort.getSortDirection(name)
  },

  setActiveState(item) {
    this.rowCanBeActivated(item) && this.setActiveItem(item)
  },

  rowCanBeActivated(item) {
    return this.rowIsSelected(item) && this.isNotActive(item)
  },

  rowIsActive(nid) {
    return this.store.listActiveItem === nid
  },

  setActiveItem(item) {
    this.store.listActiveItem = item.nid
    ChartInteractions.updateChartActiveItem()
  },

  rowIsSelected(item) {
    return !!this.store.listingDataChecked.find(checkedItem => checkedItem === item.nid)
  },

  isNotActive(item) {
    return this.store.listActiveItem !== item.nid
  },

  uncheckBulkSelect() {
    this.isBulkSelected() && (this.$refs.selectAll.checked = false)
  },

  isBulkSelected() {
    return this.$refs.selectAll.checked
  },

  get allCheckboxes() {
    return this.$el.querySelectorAll('input[type=checkbox]');
  },

  recreateCheckboxes() {
    [...this.allCheckboxes].map((box) => {
      box.checked = this.isChecked(box.dataset.nid)
    })
  },

  getFieldValue(item, name) {
    if (this.store.calculationStyle === this.store.displayStyle) {
      return item[`${this.store.calculationStyle}_${name}`]
    }

    return item[`${this.store.displayStyle}_${name}`]
  }

}

export default Listing
